<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="100004" />
    <section slot="titleRight">
      <qx-permpisions permpisions="1400309">
        <ExportBtn :len="tableData.data.length"
          queryUrl="trailerBO.ajax?cmd=doExportTrailerInfo"
          :params="fullSearchData"
          bizName="挂车档案信息导出"
          bizCode="exp100099"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'trailerNumber'">
                <span
                  class="primary cur"
                  @click="trailerDetail(scope.row, '')"
                  >{{ scope.row[scope.column.property] }}</span
                >
              </section>
              <section v-else-if="scope.column.property === 'position'">
                <span>
                  {{
                    scope.row.sourceRegionString
                      ? scope.row.sourceRegionString.replace('市', '')
                      : '-'
                  }}/{{ scope.row.sourceCountyString }}-{{
                    scope.row.stateString
                  }}
                </span>
              </section>

              <section v-else-if="scope.column.property === 'usageCount'">
                <span class="primary cur" @click="queryUsedLineList(scope.row.trailerNumber)">{{ scope.row.usageCount }}</span>
              </section>
              <section v-else>
                <span>{{ scope.row[scope.column.property] }}</span>
              </section>
            </section>
          </el-table-column>
          <el-table-column prop="control" label="操作" fixed="right">
            <template slot-scope="scope">
              <section>
                <qx-permpisions permpisions="">
                  <span
                    class="primary cur"
                    @click="showLog(scope.row.trailerId)"
                    >日志</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
        </el-table>
      </section>
      <section class="paginationBox clearPa">
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total || 0"
          ></el-pagination>
        </section>
      </section>
    </section>
  </qx-card>
</template>
<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ExportBtn from 'components/exportBtn';
import {
  queryTrailerManagement,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ExportBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'trailerNumber',
            label: '车牌号码',
            slot: true,
          },
          {
            prop: 'position',
            label: '位置状态',
            slot: true,
          },
          {
            prop: 'trailerMaterialString',
            label: '挂车材质',
          },
          {
            prop: 'usageCount',
            label: '使用情况',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: queryTrailerManagement,
    trailerDetail (item, type) {
      this.jump({
        label: `${type ? '审核' : '查看'}挂车-${item.trailerNumber}`,
        url: `/manage/car/trailer/archives/detail?id=${item.trailerId}&type=${type}`,
        full: true,
      });
    },
    queryUsedLineList (trailerNumber) {
      this.jump({
        label: '挂车使用线路',
        url: `/manage/car/trailer/common/usedLine?id=${encodeURI(trailerNumber)}`,
        full: true,
      });
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
